import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox } from 'fronton-react';
import { useRecoilState } from 'recoil';
import { dimensionsFormValues } from 'pages/dimensions/store/dimensions';
import { TFrontendConfigurationItem } from 'entries/common/widgets/context';
import { getLabelText } from '../../helpers';
import { Hint } from '../Hint';
import { CheckboxItemWrapper, FrontendCofigurationChexboxesWrapper } from './styles';

type TProps = {
  checkbox: TFrontendConfigurationItem;
};

export const FrontendConfigurationCheckboxItem = ({ checkbox }: TProps) => {
  const { defaultValue, label, name, hints } = checkbox;
  const { control, setValue } = useFormContext();
  const [hasClicked, setHasClicked] = useState(false);
  const [dimensionState] = useRecoilState(dimensionsFormValues);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formStateCbValue = (dimensionState as any)[name];
  const componentCbValue =
    formStateCbValue === undefined ? Boolean(defaultValue) : Boolean(formStateCbValue);
  const hasHints = !!hints && hints.length > 0;
  return (
    <FrontendCofigurationChexboxesWrapper>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value = defaultValue } }) => (
          <CheckboxItemWrapper>
            <Checkbox
              checked={hasClicked ? value : componentCbValue}
              label={getLabelText(label)}
              onChange={() => {
                onChange();
                setValue(name, !value);
                setHasClicked(true);
              }}
              size="l"
              variant="base"
            />
            {hasHints ? <Hint content={hints} /> : null}
          </CheckboxItemWrapper>
        )}
      />
    </FrontendCofigurationChexboxesWrapper>
  );
};
